import React from "react";
import { useTranslation } from "react-i18next";
import ukFlagImg from "../assets/img/flags/uk.png";
import ruFlagImg from "../assets/img/flags/russia.png";
import geFlagImg from "../assets/img/flags/georgia.png";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="dropdown">
      <button
        className="btn btn-light dropdown-toggle"
        type="button"
        id="languageDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{ border: 'none', background: 'none', padding: '0.5rem 1rem' }}
      >
        <span style={{ marginRight: '6px', fontSize: '16px' }}>🌍</span>
        LANGUAGE
      </button>
      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
        <li>
          <button 
            className="dropdown-item btn btn-link" 
            type="button"
            onClick={() => changeLanguage("en")}
            style={{ border: 'none', background: 'none', textAlign: 'left', width: '100%' }}
          >
            <img src={ukFlagImg} alt="English" className="language-flag me-2" /> 
            <span style={{ fontWeight: '500' }}>ENGLISH</span>
          </button>
        </li>
        <li>
          <button 
            className="dropdown-item btn btn-link" 
            type="button"
            onClick={() => changeLanguage("ru")}
            style={{ border: 'none', background: 'none', textAlign: 'left', width: '100%' }}
          >
            <img src={ruFlagImg} alt="Русский" className="language-flag me-2" /> 
            <span style={{ fontWeight: '500' }}>РУССКИЙ</span>
          </button>
        </li>
        <li>
          <button 
            className="dropdown-item btn btn-link" 
            type="button"
            onClick={() => changeLanguage("ka")}
            style={{ border: 'none', background: 'none', textAlign: 'left', width: '100%' }}
          >
            <img src={geFlagImg} alt="ქართული" className="language-flag me-2" /> 
            <span style={{ fontWeight: '500' }}>ქართული</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default LanguageSwitcher;
